import { render, staticRenderFns } from "./asignaturas.vue?vue&type=template&id=6c02ec6c"
import script from "./asignaturas.vue?vue&type=script&lang=js"
export * from "./asignaturas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports